import { defineStore } from 'pinia'

export const usePaginationStore = defineStore('pagination', {
  state: () => {
    return {
      paginationConfig: {
        itemsPerPage: 20, // Элементов на странице
        rangeSize: 1, // Страниц вокруг текущей странице
        hideFirstButton: true,
        hideLastButton: true,
      }
    }
  },
})
